import * as React from 'react'
import { cn } from '@utils';

const Page = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => (
	<div ref={ref} className={cn('flex flex-col h-screen w-full', className)} data-aid="page" {...props} />
));
Page.displayName = 'Page';

export { Page };
